const customerQueryKeys = {
    featureFlagConfig: ['customer', 'feature-flag-config'],
};

export default customerQueryKeys;
